export default __webpack_public_path__ + "static/media/cooking-background.a73b43bf.jpg";